import { render, staticRenderFns } from "./FteRoleDialog.vue?vue&type=template&id=fe708c48&scoped=true"
import script from "./FteRoleDialog.vue?vue&type=script&lang=ts"
export * from "./FteRoleDialog.vue?vue&type=script&lang=ts"
import style0 from "./FteRoleDialog.vue?vue&type=style&index=0&id=fe708c48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe708c48",
  null
  
)

export default component.exports